import React, { useState, useContext, useEffect } from 'react';
import { observer } from 'mobx-react';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import { ModalContext } from '../../../context-providers/ModalProvider';
import { coinNames } from '../../../helpers/config/coin-names';
import { marketsStore } from '../../../stores/MarketsStore';
import CryptoIconPair from '../../CryptoIconPair/CryptoIconPair';
import './SelectMarket.scss';
import ModalWrapper from '../ModalWrapper/ModalWrapper';
import { formatCurrencyAmount } from "../../../helpers/formatters";

const SelectMarket: React.FC = observer(() => {
    const { closeModal } = useContext(ModalContext);
    const [search, setSearch] = useState('');

    useEffect(() => {
        marketsStore.selectingMarket = true
        return () => {
            marketsStore.selectingMarket = false
        }
    }, []);

    useEffect(() => {
        return () => {
            marketsStore.setSearchTerm('');
        }
    }, []);
    useEffect(() => {
        marketsStore.fetchMarkets();
    }, []);

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const searchTerm = event.target.value;
        setSearch(searchTerm);
        marketsStore.setSearchTerm(searchTerm);
    };

    return (
        <ModalWrapper className="SelectMarket"
            headerChildren={<h2 className="nereus-body-m">Select Market</h2>}
            bodyChildren={<><div className="pb-4 w-full">
                <TextField
                    placeholder="Search"
                    variant="outlined"
                    value={search}
                    size="small"
                    onChange={handleSearchChange}
                    InputProps={{
                        startAdornment: (
                            <SearchIcon style={{ color: '#668295' /*neutralGrey*/ }}/>
                        )
                    }}
                    className="text-white w-full"
                />
            </div>
                <div className="SelectMarket__market-list">
                    {marketsStore.filteredMarkets.map((market) => (
                        <div onClick={() => {
                            marketsStore.selectMarket(market.marketId)
                            closeModal()
                        }} key={market.marketId} className={`SelectMarket__market ${market.popular ? 'popular' : ''}`}>
                            <CryptoIconPair
                                variant="horizontal"
                                baseTicker={market.baseAsset}
                                quoteTicker={market.quoteAsset}/>
                            <div className="flex flex-col ml-3 flex-grow">
                                {market.popular && (
                                    <div className="label-popular">Popular</div>
                                )}
                                <div className="SelectMarket__market__topLine items-center flex uppercase justify-between flex-grow nereus-body-m">
                                    <span className="pr-1.5">{market.baseAsset}/{market.quoteAsset}</span>
                                    <span>{formatCurrencyAmount(market.lastPrice, '$')}</span>
                                </div>
                                <div className="SelectMarket__market__bottomLine">
                                    <span className="nereus-caption nereus-color-neutral-grey">{ coinNames[market.baseAsset?.toUpperCase()] || market.baseAsset?.toUpperCase() }</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </>}
        />
    );
});

export default SelectMarket;
